import { all, Div, H3, reactive, Span, VArray } from 'alkali'
import Dropdown from 'components/generic/Dropdown'
import { structuredQuery } from 'model/SearchQuery'
import { selectedCharacteristics, characteristicsUpdated } from 'model/EvidenceSearch'
import * as closeIcon from 'icons/close.svg'
//import * as filterIcon from 'icons/filter-2.svg'
import * as regressionIcon from 'icons/performance-increase.svg'
import Icon from 'components/Icon'

export class CharacteristicDropdown extends Dropdown.with('.attribute-dropdown') {
	ready({ selected, attributeType }) {
		this.headerAdded = false
		let query = structuredQuery.valueOf()
		let characteristics = structuredQuery.characteristics
		let characteristicsArray = characteristics.valueOf().slice(0)
		if (characteristicsArray.length == 0) {
			this.items = [{
				content: Div([Span('.selector-checkbox.selector-selected', ['✓']), 'Filter for studies with ' + selected.label]),
				onclick: () => {
					characteristics.push(selected)
					characteristicsUpdated()
				}
			}]
			return
		}
		const findIndex = id =>
			Math.max(characteristicsArray.indexOf(characteristicsArray.find(characteristic => {
				do {
					 if ((characteristic.ids || [ characteristic.id ]).includes(id))
					 	return true
				} while(characteristic = characteristic.or)
			}), 0))
		let matchingExistingAnd = characteristicsArray.find(characteristic => characteristic.id == selected.id)
		let matchingExistingOr = characteristicsArray.find((characteristic, index) => {
			if (index > 0)
				characteristic = characteristic.or
			while(characteristic) {
				if (characteristic.id == selected.id)
					return true
				characteristic = characteristic.or
			}
		})
		let charLength = characteristicsArray.length
		let lastCharacteristic = characteristicsArray[charLength - 1]
		if (charLength >= 2 && lastCharacteristic == matchingExistingAnd)
			lastCharacteristic = characteristicsArray[charLength - 2]
		while (lastCharacteristic.or) {
			lastCharacteristic = lastCharacteristic.or
		}
		this.items =selectedCharacteristics.valueOf().filter(characteristic => 
			!(characteristic.ids || [characteristic.id]).includes(selected.id)).map((characteristic, i) => ({
			content: Div([Span('.selector-checkbox.selector-selected', {
				content: renderInitial(findIndex(characteristic.id)),
				title: 'Filtering characteristic ' + characteristic.label,
			}), 
				Span('.primary-attribute-label', [characteristic.label]), Span('.logic-operator', ['OR'])]),
			onclick: () => {
				clearCharacteristic(selected, true)
				selected.type = 'condition'
				characteristic.ids = (characteristic.ids || [ characteristic.id ]).concat([selected.id])
				characteristics.put(characteristicsArray)
				characteristicsUpdated()
				this.onSelection()
			}
		})).concat(matchingExistingOr ? [] : [{
			content: Div([
				Span('.selector-checkbox.selector-selected', [ renderInitial(characteristicsArray.indexOf(lastCharacteristic)) ]),
				'Additional characteristic', Span('.logic-operator', ['OR'])]),
			onclick: () => {
				clearCharacteristic(selected)
				selected.type = 'condition'
				selected.or = null
				if (selected.ids && !selected.ids.includes(selected.id))
					selected.ids.push(selected.id)
				lastCharacteristic.or = selected
				characteristics.put(characteristicsArray)
				characteristicsUpdated()
				this.onSelection()
			}
		}]).concat(matchingExistingAnd && !matchingExistingAnd.or ? [] : [{
			content: Div([
				Span('.selector-checkbox.selector-selected', [ renderInitial(characteristicsArray.length) ]),
				'Additional required characteristic', Span('.logic-operator', ['AND'])]),
			onclick: () => {
				clearCharacteristic(selected)
				selected.type = 'condition'
				selected.or = null
				characteristicsArray.push(selected)
				characteristics.put(characteristicsArray)
				characteristicsUpdated()
				this.onSelection()
			}
		}])
		this.removeOnly = this.items.length == 0
		if (this.removeOnly)
			this.items.push({
				content: Div([Icon({ icon: closeIcon }), 'Unselect ' + selected.label]),
				onclick: () => {
					this.onSelection(false)
				}
			})
		/*...(type == 'characteristic' ? [{
			content: Div('.disabled', [Icon({ icon: regressionIcon }), 'Analyze as predictor']),
		}] : []),
		{
			content: Div([Icon({ icon: closeIcon }), 'Unselect ' + selected.label]),
			onclick: () => {
				this.onSelection(false)
			}
		}*/
		function clearCharacteristic(selected) {
			for (let i = 0, l = characteristicsArray.length; i < l; i++) {
				let characteristic = characteristicsArray[i]
				let lastCharacteristic
				do {
					let ids = characteristic.ids || [ characteristic.id ]
					if (ids.includes(selected.id)) {
						if (characteristic.id != selected.id)
							ids.splice(ids.indexOf(selected.id), 1)
						if (ids.length == 0 || characteristic.id == selected.id) {
							if (lastCharacteristic)
								lastCharacteristic.or = characteristic.or
							else if (characteristic.or)
								characteristicsArray[i] = characteristic.or
							else
								characteristicsArray.splice(i, 1)
						}
						return
					}
					lastCharacteristic = characteristic
				} while (characteristic = characteristic.or)
			}
		}
	}
	attached() {
		super.attached()
		this.prepend(H3('.compare-as',[
			this.removeOnly ?
			this.selected.label + ':' :
			('Group ' + this.selected.label + ' with:')]))
	}
}

export const renderInitial = (position) => position > 0 ? position + 1 : '✓'
const numberToWord = (num) =>
	num == 1 ? 'primary' : num == 2 ? 'secondary' : num == 3 ? 'tertiary' : (num + 'th')
